<template>
    <div class="tab-bar">
        <div class="tab-bar-content">
            <div class="row no-gutters">
                <div class="col-3 tab-btn"
                    :class="[{'tab-active': tabActive == 'home'}, theme]">
                    <div class="icon-tab-wrapper">
                        <div class="icon-tab tab-privilege"
                            :class="[{'icon-active': tabActive == 'home'}, theme]"  @click="clickTab('home')"></div>
                    </div>
                    <div class="text-tab">{{lblTab.reward}}</div>
                </div>
                <div class="col-3 tab-btn"
                    :class="[{'tab-active': tabActive == 'news'}, theme]" @click="clickTab('news')">
                    <div class="icon-tab-wrapper">
                        <div class="icon-tab tab-news"
                            :class="[{'icon-active': tabActive == 'news'}, theme]"></div>
                    </div>
                    <div class="text-tab">{{lblTab.news}}</div>
                </div>
                <div class="col-3 tab-btn"
                    :class="[{'tab-active': tabActive == 'history'}, theme]" @click="clickTab('history')">
                    <div class="icon-tab-wrapper">
                        <div class="icon-tab tab-history"
                            :class="[{'icon-active': tabActive == 'history'}, theme]"></div>
                    </div>
                    <div class="text-tab">{{lblTab.history}}</div>
                </div>
                <div class="col-3 tab-btn"
                    :class="[{'tab-active': tabActive == 'profile'}, theme]" @click="clickTab('profile')">
                    <div class="icon-tab-wrapper">
                        <div class="icon-tab tab-profile"
                            :class="[{'icon-active': tabActive == 'profile'}, theme]"></div>
                    </div>
                    <div class="text-tab">{{lblTab.profile}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//import Util from "@/helper/Utility.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * @property {string} tabActive (required) // privilege, news, history, profile
 * @property {string} theme (required) // seller, dealer, retailer, farmer
 */
export default {
    name: "TabBar",
    props: {
        lblTab: Object,
        tabActive: String,
        theme: String,
    },
    data: function() {
        return {
            trackingService: new TrackingService(this),
        };
    },
    methods: {
        getFontTheme: function(tab) {
            // หลังจากทำ login แล้ว มาเปลี่ยนเงื่อนไขตรงนี้
            if (this.tabActive == tab) {
                switch (this.theme) {
                    case 'seller':
                        return 'text-seller';
                    case 'dealer':
                        return 'text-dealer';
                    case 'retailer':
                        return 'text-retailer';
                    case 'farmer':
                        return 'text-farmer';
                    default:
                        return '';
                }
            }
            return '';
        },

        clickTab: function(page) {
            if (this.tabActive == page) {
                return;
            }

            switch(page) {
                case 'news':
                    this.bzbTracking(page)
                    this.$router.replace('/news');
                    break;
                case 'profile':
                    this.bzbTracking(page)
                    this.$router.replace('/profile');
                    break;
                case 'history':
                    this.bzbTracking(page)
                    this.$router.replace('/history/burn');
                    break;
                case 'home':
                    this.bzbTracking(page)
                    this.$router.replace('/home');
                    break;
                default:
                    this.bzbTracking(page)
                    this.$router.replace('/');
                    break;
            }
        },
        bzbTracking: function(page) {
            var trackingEventCategory = ''
            var eventName = ''
            switch(page) {
                case 'news':
                    trackingEventCategory = 'newslist_page'
                    eventName = 'click_menu_news'
                    break;
                case 'profile':
                    trackingEventCategory = 'profile_page'
                    eventName = 'click_menu_profile'
                    break;
                case 'history':
                    trackingEventCategory = 'profile_page'
                    eventName = 'click_menu_history'
                    break;
                case 'home':
                    trackingEventCategory = 'privilagelist_page'
                    eventName = 'click_menu_privilage'
                    break;
            }
            
            this.trackingService.event(trackingEventCategory, eventName, null, null)
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "TabBar.scss";
</style>
